"use client";
import DeviceProvider from "../../../redux/features/device/DeviceProvider";
import Header from "@/app/(general-header)/header/page";

import React from "react";
import Modal from "@/app/components/Modal/modal";
import { useAppDispatch, useAppSelector } from "@/app/redux/hooks";
import { publishModalVisibility } from "@/app/redux/features/modal/modalSlice";
import { LayoutRow } from "@/app/(custom-header)/winners-template/RowLayout";
import { getTemplateConfig } from "@/app/(custom-header)/winners-template/templateConfigs";
import { resolveSlots } from "@/app/(custom-header)/winners-template/helpers";
import { useGetPageComponentsQuery } from "@/app/redux/features/api/winners";
import { useIsMobile } from "@/app/redux/features/device/selectors";
import "./winners.css";
import Skeleton from "react-loading-skeleton";

const WinnerPage = () => {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const isModalOpen = useAppSelector(state => state.modal.isOpen);
  const modalData = useAppSelector(state => state.modal.data);
  const modalOverlay = useAppSelector(state => state.modal.withOverlay);
  const modalClassNames = useAppSelector(state => state.modal.modalClassNames);
  const modalStyles = useAppSelector(state => state.modal.modalStyles);
  const onModalClose = () => {
    dispatch(publishModalVisibility({ isOpen: false }));
  };

  const { data, isLoading } = useGetPageComponentsQuery({ path: location.pathname, isMobile });

  if (isLoading) {
    return (
      <Skeleton
        count={1}
        inline
        highlightColor="#fff"
        containerClassName="block w-full"
        className="h-full min-h-[100vh] !block !rounded-none"
      />
    );
  }

  const layoutConfig = getTemplateConfig(data?.template);

  return (
    <DeviceProvider>
      <>
        <header className="sticky top-0 bg-white z-[1003] mainHeader">
          <Header renderModalComponentHere={false} />
        </header>
        <main className="block w-full overflow-hidden">
          {layoutConfig.map((row, index) => (
            <LayoutRow
              key={index}
              layoutType={row.layoutType}
              width={row.width}
              background={row.background}
              className={row.className}
              innerClassName={row.innerClassName}
              colsClassName={row.colsClassName}
              sectionClassName={row.sectionClassName}
              slots={resolveSlots(data?.PageComponents || [], row.slots)}
            />
          ))}
        </main>
        <Modal
          title=""
          body={modalData}
          isOpen={isModalOpen}
          withOverlay={modalOverlay}
          modalClassNames={modalClassNames}
          customStyles={modalStyles}
          closeModal={onModalClose}
        />
      </>
    </DeviceProvider>
  );
};

export default WinnerPage;
